import React from 'react'

import { Textarea } from 'ui/components/Textarea'

import { useSectionLongTextAttributeEditorState } from './hooks/useSectionLongTextAttributeEditorState'
import { SectionAttributeEditorProps } from './types'

type SectionLongTextAttributeEditorProps = SectionAttributeEditorProps<string>

export const SectionLongTextAttributeEditor: React.FC<SectionLongTextAttributeEditorProps> = ({
    label,
    value,
    onChange,
    isReadOnly,
    placeholder,
}) => {
    const { localValue, handleChange } = useSectionLongTextAttributeEditorState({
        value,
        onChange,
    })

    return (
        <Textarea
            size="m"
            label={label}
            value={localValue}
            onChange={handleChange}
            readOnly={isReadOnly}
            resizable
            style={{
                maxHeight: '300px',
            }}
            placeholder={placeholder}
        />
    )
}
